import { Tabs } from '@chakra-ui/react';

export const PlanningBacklogHeader = () => (
  <Tabs.List>
    <Tabs.Trigger height="3.25rem" value={0}>
      Challenge backlog
    </Tabs.Trigger>
    <Tabs.Trigger height="3.25rem" value={1}>
      HDE Modules
    </Tabs.Trigger>
  </Tabs.List>
);
